import React from 'react';
import { useTranslation } from 'react-i18next';
const ApportionmentsHeader = _ref => {
  let {
    claim,
    isShowInvolvement,
    allProjects
  } = _ref;
  const {
    t
  } = useTranslation();
  const showInvolvementHeader = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "border-start cost_categories_subpage_header_cell"
    }, "Involvement"), /*#__PURE__*/React.createElement("div", {
      className: "border-start cost_categories_subpage_header_cell"
    }, t('qualifying'), /*#__PURE__*/React.createElement("br", null), " ", t('expenditure')));
  };
  const showRndHeader = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "border-start cost_categories_subpage_header_cell"
    }, "R&D%"), /*#__PURE__*/React.createElement("div", {
      className: "border-end cost_categories_subpage_header_cell"
    }, "Months"));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, allProjects.map((_, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "d-flex cost_categories_subpage_header_cell_container",
      key: index
    }, isShowInvolvement ? showInvolvementHeader() : showRndHeader());
  }));
};
export default ApportionmentsHeader;